import { FormControl, FormGroup } from '@angular/forms';

import { GIFileType } from '@enums/gi-file-type.enum';
import { EmailAttachmentFormType } from '@forms/email-attachment-form';
import { GiEmailAttachment } from '@gi/models/gi-email-attachment';

export type ContractEmailAttachmentFormType = EmailAttachmentFormType & {
  contractFileType: FormControl<GIFileType | undefined>;
};

export class ContractEmailAttachmentForm extends FormGroup<ContractEmailAttachmentFormType> {
  get id(): FormControl<number | undefined> {
    return this.controls.id;
  }

  get file(): FormControl<Blob | undefined> {
    return this.controls.file;
  }

  get type(): FormControl<string | undefined> {
    return this.controls.type;
  }

  get name(): FormControl<string | undefined> {
    return this.controls.name;
  }

  get content(): FormControl<string | undefined> {
    return this.controls.content;
  }

  get canBeDeleted(): FormControl<boolean> {
    return this.controls.canBeDeleted;
  }

  get isSelected(): FormControl<boolean> {
    return this.controls.isSelected;
  }

  get title(): FormControl<string | undefined> {
    return this.controls.title;
  }

  get contractFileType(): FormControl<GIFileType | undefined> {
    return this.controls.contractFileType;
  }

  constructor() {
    super({
      id: new FormControl<number | undefined>(undefined),
      file: new FormControl<Blob | undefined>(undefined),
      type: new FormControl<string | undefined>(undefined),
      name: new FormControl<string | undefined>(undefined),
      content: new FormControl<string | undefined>(undefined),
      canBeDeleted: new FormControl<boolean>(true),
      isSelected: new FormControl<boolean>(true),
      title: new FormControl<string | undefined>(undefined),
      contractFileType: new FormControl<GIFileType | undefined>(undefined)
    });
  }

  static fromAttachment(attachment: GiEmailAttachment, isSelected?: boolean): ContractEmailAttachmentForm {
    const form = new ContractEmailAttachmentForm();
    form.patchValue({
      id: attachment.id,
      file: attachment.file,
      type: attachment.type,
      name: attachment.name,
      content: attachment.content,
      canBeDeleted: false,
      isSelected: isSelected ?? true,
      title: attachment.title,
      contractFileType: attachment.contractFileType
    });

    return form;
  }
}
